import E from 'services/emitter';
import { debounce } from 'utils';
import { DEV } from 'const';

const BOUND = 739;
const sizes = {
  sm: 740,
  md: 1024,
  lg: Infinity,
};

export default {
  provide () {
    return { mq: this.mq };
  },

  data: () => ({
    mq: {
      isMobile: null,
      isDesktop: null,
      sizes: {},
      pointer: {
        coarse: false,
        fine: false,
      }
    },
  }),

  methods: {
    onResize (e) {
      const { innerWidth: W, innerHeight: H } = window;
      if (W === this.lastWidth)
        return;
      this.lastWidth = W;

      const sizesEntrs = Object.entries(sizes);
      const isDesktop = W > BOUND;
      const [sizeName] = sizesEntrs.find(([name, size]) => W < size);

      if (DEV)
        this.detectPointer();

      this.mq.isMobile = !isDesktop;
      this.mq.isDesktop = isDesktop;
      Object.assign(this.mq, sizesEntrs.reduce((acc, [name, size]) => {
        acc[name] = sizeName === name;
        return acc;
      }, {}));
      this.mq.width = W;
      this.mq.height = H;

      E.emit('resize', e, this.mq);
    },

    detectPointer () {
      this.mq.pointer.coarse = window.matchMedia('(pointer: coarse)').matches;
      this.mq.pointer.fine = window.matchMedia('(pointer: fine)').matches;
    },
  },

  created () {
    this.detectPointer();
    this.onResizeDebounced = debounce(this.onResize, 500);
    window.addEventListener('resize', this.onResizeDebounced, true);
  },

  mounted () {
    this.onResize();
  },
};
